/**
 * Paths that must never be resumed after signing in.
 *
 * `/unauthorized` and `/404` sit inside ProtectedRoute, so a session that drops while one of
 * them is open would be captured as the login `from` and replayed on the next sign-in —
 * landing the user straight back on Access Denied every time, until they edit the URL by hand.
 */
const NON_RESUMABLE_PATHS = new Set(['/login', '/unauthorized', '/404']);

/** The path to return to after login, or undefined when the current one is not worth resuming. */
export function resumablePath(pathname: string): string | undefined {
  return NON_RESUMABLE_PATHS.has(pathname) ? undefined : pathname;
}
